// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "bundle." + {"25":"99b5bff3c098544ec2db","155":"cec2ea4860a5cdf24980"}[chunkId] + ".js";
};